import { Route } from '@angular/router';
import { Injectable } from '@angular/core';
import {
  CanActivate,
  ActivatedRouteSnapshot,
  RouterStateSnapshot,
  UrlTree,
  Router,
  CanLoad,
  UrlSegment,
} from '@angular/router';
import { Observable } from 'rxjs';
import { SessionService } from './session.service';
import { LoggedInUserRole } from './session.model';

@Injectable({
  providedIn: 'root',
})
export class RoleGuard implements CanLoad {
  constructor(private session: SessionService, private router: Router) {}

  canLoad(route: Route, segments: UrlSegment[]) {
    if (!segments || segments.length === 0) return true;
    let userRoleId = this.session.userRole;
    let path = segments[0].path;

    if (userRoleId === LoggedInUserRole.SUPER_ADMIN) {
      if (path !== 'super-admin') {
        this.router.navigate(['/super-admin']);
        return false;
      }
      return true;
    }

    if (userRoleId === LoggedInUserRole.ADMIN) {
      if (path === 'super-admin') {
        this.router.navigate(['/admin-dashboard']);
        return false;
      }
      return true;
    }

    if (path === 'admin-dashboard' || path === 'super-admin') {
      this.router.navigate(['/dashboard']);
      return false;
    }

    return true;
  }
}
